module.exports = __webpack_public_path__ + "assets/img/6_560_big.75f2044d.jpg";